<template>
<div class="page">
  <input type="text" class="single_text_input" v-model="value">
  <div v-html="value"></div>
</div>
</template>
<script>
export default {
  data () {
    return {
      value:'\n问题是<pre>哈哈哈哈</pre>'
    }
  },
  components: {
  },
  created () {
    
  },
  mounted () {
  },
  computed:{
  },
  methods: {
    
  }
}
</script>
<style lang="less" scoped>
.page{
  height: 100vh;
  padding: 100px 0 0 150px;
  box-sizing: border-box;
  background-color: pink;
}
.single_text_input{
  width: 70%;
  padding: 15px 20px;
  font-size: 28px;
  border: 1px solid #f3eded;
  border-radius: 6px;
  color: #333;
  background-color: #fbfbfb;
}
</style>



// WEBPACK FOOTER //
// src/views/survey/test.vue